import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Projects from './Projects';
import HomeSeekarForm from '../../components/ModalForm/HomeSeekarForm';
import BuilderForm from '../../components/ModalForm/BuilderForm';
import ChannelPartnerForm from '../../components/ModalForm/ChannelPartnerForm';
import { Dialog } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ProjectsPage: React.FC = () => {
  const [openForm, setOpenForm] = useState(false);
  const [hasShownPopup, setHasShownPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    message: '',
    iAgree: false,
    homeLoan: false,
    projectName: '',
    companyName: '',
  });

  const navigate = useNavigate();
  const userType = localStorage.getItem('userType');

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasShownPopup) {
        setOpenForm(true);
        setHasShownPopup(true);
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, [hasShownPopup]);

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmitForm = () => {
    console.log('Form Submitted:', formData);
    setOpenForm(false);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
  };

  return (
    <>
      <Helmet>
        <title>Best Apartments in Hyderabad, Villas and Plots</title>
        <meta name="description" content="Own your dream home. Explore our exclusive list of top properties, luxury flats, premium villas and best apartments in Hyderabad" />
        <meta name="keywords" content="flats for sale in hyderabad, apartments for sale in hyderabad, buy flat in hyderabad, apartment flat for sale in hyderabad, villas for sale in hyderabad, plots for sale in hyderabad, 3 bhk flats for sale in hyderabad, 2 bhk flat for sale in hyderabad, gated community villas in hyderabad, flats for sale in gachibowli, flats for sale in kondapur, flats in hyderabad, hyderabad real estate" />
      </Helmet>
      
      {/* <Dialog open={openForm} onClose={handleCloseForm}
        sx={{
          '& .MuiDialog-paper': {
            height: '75vh',
            maxHeight: '75vh',
          },
        }}>
        {userType === 'homeSeeker' ? (
          <HomeSeekarForm
            formData={formData}
            handleFormChange={handleFormChange}
            handleSubmitForm={handleSubmitForm}
            handleCloseForm={handleCloseForm}
          />
        ) : userType === 'builder' ? (
          <BuilderForm
            formData={formData}
            handleFormChange={handleFormChange}
            handleSubmitForm={handleSubmitForm}
            handleCloseForm={handleCloseForm}
          />
        ) : userType === 'channelPartner' ? (
          <ChannelPartnerForm
            formData={formData}
            handleFormChange={handleFormChange}
            handleSubmitForm={handleSubmitForm}
            handleCloseForm={handleCloseForm}
          />
        ) : null}
      </Dialog> */}
      
      <Projects />
    </>
  );
};

export default ProjectsPage;
